<template>
  <b-overlay :show="$root.loading"
             spinner-variant="primary"
             spinner-type="grow"
             opacity="0.95">
    <div class="cont-steps">

      <header-component class="align-self-start"></header-component>

        <div id="appscroll" class="content-app" :class="{withFooter:$root.footer}">
          <transition name="zoom-fade" mode="out-in">
            <router-view
                :options="options"
                @updateOptions="updateOptions"
                class="py-4"
            />
          </transition>
        </div>

    </div>
  </b-overlay>
</template>

<script>
import HeaderComponent from "@/components/HeaderComponent";
export default {
  name: 'ConfiguratoreSerena',
  metaInfo: {
    title: 'Configuratore Serena - Astea Energia',
    meta: [
      {
        name: 'description',
        content: 'Scopri i vantaggi di passare a Serena: la risposta migliore ai rincari.'
      }
    ]
  },
  data() {
    return {
      result: null,
      webPath: process.env.VUE_APP_WEB_PATH,

      options: {
        seiCliente: null,
        comune: null,
        cliente: null,
        forniture: null,
        consumo: null,
        rate: null,
      },
      showResults: false,
    }
  },
  created() {

    let options = JSON.parse(sessionStorage.getItem('options'));
    if (!this._.isEmpty(options)) this.options = options;

    if (typeof this.$route.query.comune !== 'undefined') {
      let comune = {
        data: this.$route.query.comune,
      };
      this.options.comune = comune;
    }
  },
  methods: {
    updateOptions(options) {
      this.options = options;
      sessionStorage.setItem('options', JSON.stringify(options));
    }
  },
  components: {HeaderComponent},
}
</script>

<style lang="scss">
body, label {
  font-family: "Montserrat";
}
.content-app {
  max-height: calc(var(--vh, 1vh) * 100 - 64px);
  height: calc(var(--vh, 1vh) * 100 - 64px);
  overflow: auto;

  & > div {
    width: 100%;
    max-height: 100%;
  }

  &.withFooter {
    max-height: calc(var(--vh, 1vh) * 100 - 144px);
    height: calc(var(--vh, 1vh) * 100 - 144px);
  }
}

.cont-steps {
  flex-wrap: wrap;
  height: calc(var(--vh, 1vh) * 100);

  & > header,
  & > div {
    width: 100%;
  }
}

.h3-semibold-black {
  //font-size: 24px;
  font-weight: 600;
  color: #191C21;
}

.h4-semibold-black {
  font-weight: 600;
  color: #191c21;
  letter-spacing: 0;
  font-size: 20px;
  line-height: 24px;
}

.config-button-element {
  cursor: pointer;
  text-align: center;
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  color: #00205b;
  background: #ECF1F4 0% 0% no-repeat padding-box;
  opacity: 1;
  margin: 12px;
  font-size: 24px;
  line-height: 40px;
  font-weight: bold;

  i {
    font-size: 120px;
    margin-bottom: 30px;
    display: block;
    margin-left: 8px;
  }

  & + .config-button-element {
  }

  &:hover {
    box-shadow: 0px 1px 2px #00000029;
  }

  &.isActive {
    background: rgb(12, 47, 123);
    background: linear-gradient(108deg, rgba(12, 47, 123, 1) 0%, rgba(0, 144, 223, 1) 100%);
    box-shadow: 0px 1px 2px #00000029;
    color: #FFFFFF;
  }
}

.form-group {
  label {
    color: #191C21;
    line-height: 20px;
  }

  .form-control {
    &.form-control-gray-900 {
      font-size: 18px;
      border-radius: 28px;
      padding: 16px 24px;
      font-weight: 500;
      @media screen and (max-width: 340px)
      {
        font-size: 15px;
      }
      &:not(textarea){
      height: 54px !important;
      }
    }
  }
  button[type=submit] {
    font-size: 18px;
  }
  textarea{
    overflow-y: auto !important;
  }

  .input-group {
    & > .custom-select, & > .form-control {
      &:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }

    .input-group-append {
      .input-group-text {
        font-size: 18px;
        font-weight: 500;
        padding-right: 22px;
        border-top-right-radius: 28px;
        border-bottom-right-radius: 28px;
      }
    }
  }
}

.box-rata {
  position: relative;
  border-radius: 12px;
  background-blend-mode: multiply;
  background-image: url("../assets/images/bg-rata.jpg"), linear-gradient(120deg, rgba(12, 47, 123, 0.2), rgba(0, 144, 223, 0.2));
  background-position: center;
  background-size: cover;
  width: 500px;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 22px;
  box-shadow: 0px 3px 6px #00000029;
  & > .rata{
    position: relative;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin-top: 12px;
  }

  .icon {
    font-size: 66px;
    color: #FFFFFF;
  }

  .icon.icon-white {
    &::before {
      color: white !important
    }
  }

  .small-text-azure {
    font-size: 10px;
    color: #00205b;
    line-height: 16px;
    font-weight: 400;
  }

  .big-text-yallow {
    font-size: 60px;
    line-height: 1;
    color: #FECD4B;
    font-weight: 800;
  }

  .h4-regular-white {
    font-size: 18px;
    color: #FFFFFF;
    font-weight: 400;
    line-height: 32px;
  }
}
.after-box-rata{
  margin: 0 6px;
  background: #ECF1F4;
  border-radius: 12px;
  position: relative;
  z-index: -1;
  margin-top: -30px;
  padding: 40px 12px 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  .box-single-rata{
    width: 50%;
    display: flex;
    align-items: center;
    gap: 12px;
    .icon{
      font-size: 40px;
      color: #00205b;
    }
    .box-price{
      .price{
        color: #191C21;
        font-size: 20px;
        line-height: 1.2;
        font-weight: 700;
      }
      .label{
        color: #516574;
        font-size: 12px;
        line-height: 16px;
        font-weight: 500;
      }
    }

    & + .box-single-rata{
      position: relative;
      &:before{
        content: '';
        position: absolute;
        left: -10px;
        top: 0;
        width: 1px;
        height: 100%;
        background: #fff;
      }
    }
  }

}

.btn-primary {
  border-radius: 28px;
  background: #00205b;
  border: 2px solid #00205b;
  font-size: 16px;
  font-weight: 700;
  color: #FFFFFF;
  line-height: 24px;
  padding: 10px;

  &:hover {
    background: darken(#00205b, 10);
    border-color: darken(#00205b, 10);
  }

  &.btn-outline {
    background: transparent;
    color: #00205b;

    &:hover {
      color: darken(#00205b, 10);
      border-color: darken(#00205b, 10);
    }
  }
}

.h6-bold-azure-underline {
  text-align: left;
}

.form-control {
  &.isPlaceholder {
    color: #adb0b4 !important;
    font-weight: 400 !important;

    option {
      color: rgba(36, 55, 112, 1) !important;
    }
  }
}

.modal-full {
  .modal-dialog {
    margin: 0 !important;
    width: 100%;
    max-width: none !important;
    height: 100%;
    max-height: 100% !important;

    .modal-content {
      border: none;
      border-radius: 0;
      max-height: 100% !important;
      height: 100%;

      .modal-header {
        border: none;
        border-radius: 0;

        .modal-title {
          @extend .h3-semibold-black;
        }

        .close {
          opacity: 1;
        }
      }
    }
  }
}
.modal-alert{
  .modal-dialog{
    .modal-content{
      .modal-header {
        border: none;
        border-radius: 0;
        padding-bottom: 0;
      }
      .modal-body{
        padding-top: 0;
        img{
          height: 100px;
          margin-bottom: 24px;
        }
      }
      .modal-footer{
        display: none;
      }
    }
  }
}

.b-form-datepicker{
  display: flex !important;
  align-items: center !important;
  label{
    text-align: left;
  }
  .dropdown-menu{
    transition: none !important;
    footer{
      display: none !important;
    }
  }
}

.alert-danger{
  background: #e83e34;
  color: #fff;
  text-align: center;
  padding: 8px 8px;
  border-radius: 30px;
  max-width: 100%;
  width: 100%;
  font-size: 0.8em;
}

@media (min-width: 992px) {
  .content-app {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@media (max-width: 991px) {
  .cont-steps {
    display: block;
  }

  .h3-semibold-black {
    line-height: 30px;
  }
  .config-button-element {
    min-height: auto;
    margin: 0;

    i {
      font-size: 100px;
      margin-bottom: 8px;
    }
  }
  .image-col {
    display: none !important;
  }
}
@media (max-width: 568px) {
  .h3-semibold-black {
    font-size: 20px;
    line-height: 28px;
  }
  .h2-semibold-azure {
    font-size: 24px;
  }
  .p-medium-gray-600 {
    font-size: 14px;
    line-height: 22px;
  }
  .config-button-element {
    min-height: auto;
    margin: 0;
  }
}
.modal-fail {
  background: white;
  .modal-content {border: 0px;}
}

@media (max-width: 340px) {
  .box-rata {
    .big-text-yallow {
      font-size: 50px;
    }
  }
}
</style>
